import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminSubscriptionOrderType } from '../enums/admin-subscription-order-type';

@Injectable({
  providedIn: 'root',
})
export class AdminSubscriptionOrderTypeProviderService {
  private readonly entries = new Map<AdminSubscriptionOrderType, string>([
    [AdminSubscriptionOrderType.Renewal, 'Odnowienie subskrypcji'],
    [AdminSubscriptionOrderType.First, 'Pierwsze zamówienie'],
    [AdminSubscriptionOrderType.Resubscribe, 'Wznowienie subskrypcji'],
  ]);

  public labelFor(status: AdminSubscriptionOrderType): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<AdminSubscriptionOrderType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) =>
          new SelectItem<AdminSubscriptionOrderType>(label, type),
      ),
    );
  }
}
